import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import EnterpriseTriggerToolTabs from 'bundles/internal-enterprise/components/trigger/EnterpriseTriggerToolTabs';

class EnterpriseTriggerContainer extends React.LegacyComponentWithChildren {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof EnterpriseTriggerContainer.contextTypes>;

  render() {
    return (
      <div className="rc-UserMembershipRouteHandler">
        <EnterpriseTriggerToolTabs />
        {this.props.children}
      </div>
    );
  }
}

export default EnterpriseTriggerContainer;
